module.exports = __webpack_public_path__ + "img/filter.7d567d10.svg";